<header>
	<div class="row">
		<div class="col-lg-4 d-flex justify-content-start align-items-center">
			<img src="assets/img/shared/alamat-logo.svg" alt="" class="logo">
		</div>
		<div class="col-lg-8 d-flex justify-content-between align-items-center flex-wrap">
			<button class="nav">
				<a routerLink="/" class="t-fs16">Home</a>
			</button>
			<button class="nav">
				<a routerLink="/landing/gameplay-legendary" class="t-fs16">Gameplay</a>
			</button>
			<button class="nav">
				<a href="#" class="t-fs16">Cards</a>
			</button>
			<button class="nav">
				<a href="#" class="t-fs16">Rankings</a>
			</button>
			<button class="nav">
				<a href="#" class="t-fs16">Tournaments</a>
			</button>
			<button class="nav">
				<a routerLink="/landing/manual" class="t-fs16">Manual</a>
			</button>
			<button class="nav">
				<a href="#" class="t-fs16">Contact Us</a>
			</button>
			<button class="nav">
				<a routerLink="/landing/privacy-policy" class="t-fs16">Privacy & Policy</a>
			</button>

			<button class="sign-in" (click)="openLoginModal()">
				Sign In
			</button>
		</div>
	</div>
</header>